import IProduct from "../products/IProduct"

export enum WiplineStatus {
    Pending = 0,
    Orderable = 10,
    ToOrder = 40,
    OnOrder = 50,
    Ready = 60,
    Completed = 100
}

export enum LinePricingType {
    Subordinate = -100,
    Standard = 0,
    Dominant = 100
}

export interface IWipLine {
    id: string, 
    created: string,
    created_by: string, 
    status: WiplineStatus,
    job_number: string,
    quantity: number,
    name: string,
    engineer_id: string,
    supplier_id: string | null,
    order_number: string | null,
    line_type: string,
    notes: string | null,
    time_zone_id: string,
    is_assessed: boolean,
    is_re_assessment: boolean,
    is_order_line: boolean,
    is_picked_up: boolean,
    is_damage_line: boolean,
    expected_date: string | null,
    price_description: string,
    trade_price: number,
    manual_coshh_id: string | null,
    custom_risk_assessment: boolean | null,
    line_data: {
        product_id:string, 
        calculate_price_description?: string,
        modifiers: string[],
        creation_plan_id?: string,
        time_zone_id?: string,
        requirements: string[]
    },
    version:string,
    pricing_type: LinePricingType
}

export interface IWipLines {
    lines: IWipLine[]
}